<template>
  <div :class="['agreementBox', { inApp: $root.$data.isApp }]">
    <template>
      <common-title
        :titleName="titleName"
        v-if="!$root.$data.isApp"
        :bcColor="'#FEFEFF'"
        :zIndex="1000"
      ></common-title>
      <div :class="['agreementContent']">
        <!-- pdf链接 -->
        <div class="iframeFather" v-if="detailBox.type === 1">
          <iframe id="iframeUi" :src="src + '#toolbar=0'" frameborder="0"></iframe>
        </div>
        <!-- 富文本 -->
        <div v-if="detailBox.type === 2">
          <div v-html="detailBox.introduction"></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';


export default {
  components: {
    CommonTitle,
  },
  data() {
    return {
      detailBox: {},
      titleName: '协议',
      type: '', // 协议类型 1pdf 2富文本
      src: '', // pdf文件地址
    };
  },

  computed: {},
  mounted() {
    this.parseQueryParams();
  },
  methods: {
    parseQueryParams() {
      try {
        const itemStr = this.$route.query.xieyiInfo;
        if (itemStr) {
          const item = JSON.parse(decodeURIComponent(itemStr));
          if (item.name) {
            this.titleName = item.name;
          }
          
          if (item.type || item.introduction || item.pdfAddress) {
            this.detailBox = {
              type: item.type || 1, 
              introduction: item.introduction || '',
              url: item.pdfAddress || ''
            };
            
            if (item.type === 1 && item.pdfAddress) {
              this.src = item.pdfAddress;
            }
          }
        }
      } catch (error) {
        console.error('解析URL参数失败:', error);
      }
    },
  },
  beforeDestroy() {
  },
};
</script>

<style lang="scss" scoped>
.agreementBox {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding-top: 100px;
  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }
  .agreementContent {
    padding: 10px 30px 30px 30px;
    background: #fff;
    .iframeFather {
      // -webkit-overflow-scrolling: touch; /* 当手指从触摸屏上移开，会保持一段时间的滚动 */
      // overflow-y: scroll;
      #iframeUi {
        width: 100%;
        height: 100vh;
      }
    }
  }
  .agreementContent.paddUi {
    padding-bottom: 150px;
    .iframeFather {
      #iframeUi {
        height: 82vh;
      }
    }
  }
}
.toolbar {
  display: none !important;
}
</style>
